import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";
import { fetchApiGet, fetchApiPost } from "./utils";

export const GenerateAgtechReportBodyValidation = z.object({
  start_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  end_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});

export interface GenerateAgtechReportResponse {
  document_id: string;
  presigned_get_url: string;
}

export interface QueueStats {
    name: string;
    type: string;
    pending: number;
    processing: number;
    completed: number;
    failed: number;
    halted: number;
    oldest_pending: Date | null | undefined;
}

export function useGenerateAgtechReport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: z.infer<typeof GenerateAgtechReportBodyValidation>) => {
      return fetchApiPost<GenerateAgtechReportResponse>(
        "contracts/reports/release/generate",
        data
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["agtech", "reports"] });
    },
  });
}

export function useGetAgtechSyncStats(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ["agtech", "reports", "stats"],
    queryFn: () => fetchApiGet<QueueStats>("contracts/reports/stats"),
    retry: 1,
    enabled: options?.enabled,
  });
}
